<template lang="html">
<div class="v-scope-eventos-evento-el-fake">
<article class="evento-el">

    <div class="contenedor-texto column-start">
      
      <nav class="tags">
        
        <router-link class="tag -white" to=""></router-link>
  
      </nav>

      <h2 class="fake--title-dato -white"></h2>

      <div class="info row-start">
        <p class="fake"></p>
        <p class="fake"></p>
      </div>

    </div>
    
  </article>
</div>
</template>

<script lang="js">
  export default  {
    name: 'evento-el',
  }
</script>



// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/views/eventos/evento-el-fake.vue